import { NgModule } from '@angular/core';
import { ManualComponent } from './manual.component';
import { HeaderModule } from 'src/app/controls/header/header.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [ManualComponent],
    imports: [HeaderModule, CommonModule, FormsModule],
    exports: [ManualComponent],
    providers: [],
    bootstrap: [ManualComponent]
})
export class ManualModule { }